import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useState } from 'react';

import { webhookService } from '../../application/WebhookService';
import { EventType } from '../../domain/webhook/EventType';
import { Webhook } from '../../domain/webhook/Webhook';
import { useShowSnackbarMessage } from '../snackbarMessage/useShowSnackbarMessage';

type UseTestWebhookProps = ServiceResponse<(event: EventType) => Promise<void>, void>;

// Hooks act as 'Adapter' layer.
export const useTestWebhook = (webhook: Webhook): UseTestWebhookProps => {
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const run = async (event: EventType): Promise<void> => {
    setLoading(true);
    try {
      await webhookService.testWebhook(webhook, event);
      showSnackbarMessage({
        messageIntlId: `settings.developers.webhooks.test_sent`,
        type: `success`,
      });
      setSuccess(true);
    } catch (err: any) {
      showSnackbarMessage({
        messageIntlId: `infoerror.${err.response.data.messageId}`,
        type: `error`,
      });
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return {
    error,
    success,
    isLoading,
    run,
  };
};
